import React from "react";
import { TrendingUp } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Stats = () => {
  const { seasonStats, measurables } = useContent();
  return (
    <section id="stats" className="relative py-24 md:py-32 bg-black">
      <div className="absolute inset-0 field-lines opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="accent-bar" />
              <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
                02 — {seasonStats.season}
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
              BY THE <span className="text-red-600">NUMBERS</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 text-red-500 font-heading text-sm uppercase tracking-widest">
            <TrendingUp className="w-4 h-4" /> Elite Sack Production
          </div>
        </div>

        {/* Season stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-12">
          {seasonStats.items.map((s) => (
            <div
              key={s.label}
              className="stat-card relative border border-neutral-800 bg-neutral-900/60 rounded-sm p-6 md:p-8"
            >
              <div className="absolute top-0 left-0 w-full h-[3px] bg-red-600" />
              <div className="font-display text-6xl md:text-7xl text-white leading-none">
                {s.value}
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.25em] text-neutral-400 font-heading">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* Measurables */}
        <div className="border-t border-neutral-900 pt-10">
          <h3 className="font-heading text-sm uppercase tracking-[0.3em] text-neutral-400 mb-6">
            Physical Profile
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {measurables.map((m) => (
              <div
                key={m.label}
                className="stat-card border border-neutral-800 bg-neutral-950 rounded-sm p-4"
              >
                <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-heading">
                  {m.label}
                </div>
                <div className="mt-2 font-display text-2xl text-white">
                  {m.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
